import React from 'react';

import { FormSelect } from '../../../app/components/FormSelect';

interface EmploymentCandidateSelectorProps {
  value?: boolean | null;
  onChange: (value: boolean) => void;
}

export const EmploymentCandidateSelector: React.FC<
  EmploymentCandidateSelectorProps
> = ({ value, onChange }) => {
  const toStringValue = () => {
    if (value === undefined || value === null) {
      return undefined;
    }
    return value ? 'true' : 'false';
  };

  return (
    <FormSelect
      value={toStringValue()}
      options={[
        { value: 'false', label: 'Pracownik' },
        { value: 'true', label: 'Kandydat do pracy' },
      ]}
      onChange={v => onChange(v === 'true')}
    />
  );
};
